import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { default as SiteMenu, linkTypes } from './SiteMenu';
import { Col, Row, Typography } from 'antd';
import { Contract, User } from 'tree-wallet-client';
import { GlobalContext } from '../../Contexts/GlobalContext';
import MenuContractSelector from './MenuContractSelector';
import { downloadKML } from '../../Repository/TreeRepository';


const { Title } = Typography;

// @ts-ignore
import logo from '../../../assets/icons/usf-logo-blue.png';

export default class MobileMenu extends SiteMenu {
  static contextType = GlobalContext;
  declare context: React.ContextType<typeof GlobalContext>;

  async saveOffline() {
    this.toggle();
    await super.saveOffline();
  }

  downloadkmlfile() {
    const { setShowLoader } = this.props;
    const { filter } = this.context;
    if (setShowLoader) {
      downloadKML(setShowLoader, filter);
      this.toggle(); // Keep toggle for mobile menu
    }
  }

  render() {
    const { opened } = this.state;
    const { user, contract } = this.context;

    return <div className='menu mobile'>
      <div className={'mobile-menu-toggle'}>
        <img onClick={this.toggle} src={logo} style={{ height: '50px' }} alt="my image" />
      </div>
      <nav className={'nav' + (opened ? ' expanded' : '')}>
        <Row>
          <Col span={8}>
            <img src={logo} />
          </Col>
          <Col offset={10} span={6}>
            <span className={'close-btn'} onClick={this.toggle}>X</span>
          </Col>
        </Row>
        <Row style={{ textAlign: 'center', margin: '20px 0', visibility: 'hidden', display: 'none' }}>
          <Col span={18} offset={3}>
            <div><Title level={4} style={{ color: 'white' }}>Current contract</Title></div>
            <div><MenuContractSelector /></div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <ul style={{ height: '100%', width: '100%', textAlign: 'center', margin: '40px 0 0 0' }}>
              {this.getLinks().map((link: any) => this.renderLink(user, contract, link))}
            </ul>
          </Col>
        </Row>
        <div id={'mobile-version-number'}>
          <div>Build 26101300</div>
        </div>
      </nav>
    </div>
  }

  renderLink(user: User | undefined, contract: Contract | undefined, link: any) {
    const { navigate } = this.context;

    if (!this.shouldDisplayLink(user, contract, link)) {
      return null;
    }

    const template = (link: any) => {
      const linkProps = { style: { color: '#fff' }, className: 'menu-link' };
      switch (link.type) {
        case linkTypes.logout:
          return <NavLink to={'/'} onClick={() => link.onClick(navigate)}>{link.text}</NavLink>;
        case linkTypes.btn:
          return <span {...linkProps} onClick={() => link.onClick()}>{link.text}</span>;
        default:
          return <NavLink {...linkProps} to={link.link}>{link.text}</NavLink>;
      }
    }

    return (
      <li key={"1" + link.link} className={'menu-link'}>
        {link && template(link)}
      </li>
    );
  }
}